import React, { useState, useEffect } from 'react';
import Spline from '@splinetool/react-spline';
import { ArrowRight, Gift } from 'lucide-react';
import { useParallax } from '../hooks/useScrollAnimation';

export const HeroSection = () => {
  const [parallaxRef, offsetY] = useParallax(0.3);
  const [displayText, setDisplayText] = useState('');
  const fullText = 'Automate Your Growth with Custom AI Agents';
  
  useEffect(() => {
    let index = 0;
    const timer = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayText(fullText.slice(0, index));
        index++;
      } else {
        clearInterval(timer);
      }
    }, 50);
    
    return () => clearInterval(timer);
  }, []);
  
  const scrollToContact = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };
  
  const scrollToTech = () => {
    document.getElementById('tech')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section" ref={parallaxRef}>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badges">
            <div className="hero-badge animate-fade-in">
              <span className="badge-dot"></span>
              <span className="badge-text">AI-Powered Automation</span>
            </div>
            
            <div className="trial-badge animate-fade-in animation-delay-200">
              <Gift size={16} className="trial-icon" />
              <span className="trial-text">1 Month Free Trial</span>
            </div>
          </div>
          
          <h1 className="hero-headline animate-slide-in-left animation-delay-200">
            {displayText}
            <span className="cursor-blink">|</span>
          </h1>
          
          <p className="hero-subheadline animate-slide-in-left animation-delay-400">
            We build enterprise-grade n8n workflows and AI systems that handle manual tasks 24/7 so you can focus on scaling.
          </p>
          
          <div className="hero-cta-group animate-fade-in-up animation-delay-600">
            <button className="btn-primary" onClick={scrollToContact}>
              <span>Start Free Trial</span>
              <ArrowRight className="btn-icon" size={20} />
            </button>
            
            <button className="btn-secondary" onClick={scrollToTech}>
              <span>View Our Tech Stack</span>
            </button>
          </div>
          
          <div className="hero-stats animate-fade-in-up animation-delay-800">
            <div className="stat-item">
              <div className="stat-value">24/7</div>
              <div className="stat-label">Operation</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-value">100%</div>
              <div className="stat-label">Automated</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-value">Zero</div>
              <div className="stat-label">Manual Work</div>
            </div>
          </div>
        </div>
        
        <div 
          className="hero-visual animate-float" 
          style={{ transform: `translateY(${offsetY * 0.5}px)` }}
        >
          <div className="spline-container">
            <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
          </div>
        </div>
      </div>
    </section>
  );
};
